/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Keen_Crane_SoarInputs */

const en_warm_keen_crane_soar = /** @type {(inputs: Warm_Keen_Crane_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Date`)
};

const de_warm_keen_crane_soar = /** @type {(inputs: Warm_Keen_Crane_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enddatum`)
};

/**
* | output |
* | --- |
* | "End Date" |
*
* @param {Warm_Keen_Crane_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_keen_crane_soar = /** @type {((inputs?: Warm_Keen_Crane_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Keen_Crane_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_keen_crane_soar(inputs)
	return de_warm_keen_crane_soar(inputs)
});